export type Note = {
  note_id: string;
  user_id: string;
  body: string;
  is_pinned: boolean;
  created_at: string;
  author_agent_id: string;
  author_agent_email: string;
  pinned_at: string | null;
  pinned_by_agent_id: string | null;
  pinned_by_agent_email: string | null;
  updated_at: string | null;
  deleted_at: string | null;
  deleted_by_agent_id: string | null;
};

export type ListUserNotesResponse = {
  success: boolean;
  data: Note[];
  last_evaluated_key: string | null;
};

export type SingleUserNoteResponse = {
  success: boolean;
  data: Note;
  message?: string;
};

export type DeleteUserNoteResponse = {
  success: boolean;
  message?: string;
};

export const USER_NOTES_QUERY_KEY = "userNotes";

export const userNotesQueryKey = (userId: string) =>
  [USER_NOTES_QUERY_KEY, userId] as const;

export const DEFAULT_USER_NOTES_LIMIT = 20;

export const NOTE_BODY_MAX_LENGTH = 1000;
